import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function LastAutomaticImport() {
  const [item, setItem] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${API}/poker/report-schedule/last-import`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(response => setItem(response.data?.item || null))
      .catch(error => console.log('No se pudo obtener la última importación automática:', error));
  }, []);

  if (!item?.loaded_at) return null;

  return (
    <div className="mb-3 rounded-md bg-white/70 dark:bg-gray-900/40 px-3 py-2 text-sm text-gray-700 dark:text-gray-200">
      <span className="font-semibold text-violet-700 dark:text-violet-300">🤖 Automatización PPPoker:</span>{' '}
      {new Date(item.loaded_at).toLocaleString('es-AR', {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        timeZone: 'America/Argentina/Buenos_Aires'
      })}
      <span className="ml-2 text-xs text-gray-500 dark:text-gray-400">Jornada {item.day}</span>
    </div>
  );
}
